export const FETCH = "_FETCH";
export const DONE = "_DONE";
export const FAIL = "_FAIL";
export const RESET = "_RESET";
export const HANDLE = "_HANDLE";
export const ADD = "_ADD";
export const ONE = "_ONE";
export const DELETE = "_DELETE";
export const EDIT = "_EDIT";
export const SET = "_SET";
export const GET = "_GET";
export const POST = "_POST";
export const PUT = "_PUT";


//auth
export const AUTH = "AUTH";
export const REGISTER_DATA = "REGISTER_DATA"
export const EMBED_DATA = "EMBED_DATA"

export const RESTORE_DATA = "RESTORE_DATA"
export const GET_PROFILE = "GET_PROFILE"
export const GET_MODULES = "GET_MODULES"

export const LOGOUT = "auth/LOGOUT";

export const PROFILE = "PROFILE";
export const NOTIFICATION = "NOTIFICATION";
export const VISIT = "VISIT";

export const SPECIALISTS = "SPECIALISTS";

export const PROFILE_ROLE = "PROFILE_ROLE"
export const PROFILE_ROLE_NAME = "PROFILE_ROLE_NAME"

//materials

//materials - game
export const MATERIALS_GAME_CATEGORIES = "MATERIALS_GAME_CATEGORIES"
export const MATERIALS_GAMES = "MATERIALS_GAMES"
export const MATERIALS_GAME = "MATERIALS_GAME"
export const MATERIALS = "MATERIALS"
export const INFOGRAPHICS = "INFOGRAPHICS"

export const MATERIALS_CARDS = "MATERIALS_CARDS"
export const MATERIALS_CARD = "MATERIALS_CARD"
export const TALES = "TALES"

export const MATERIALS_TREE = "MATERIALS_TREE"
export const MATERIALS_DETAIL = "MATERIALS_DETAIL"
//screening

//screening - tests
export const SCREENING_TESTS_LIST = "SCREENING_TESTS_LIST"
export const SCREENING_TESTS_EARLY_LIST = "SCREENING_TESTS_EARLY_LIST"
export const SCREENING_ONE_TEST = "SCREENING_ONE_TEST"
export const SCREENING_ONE_EARLY_TEST = "SCREENING_ONE_EARLY_TEST"
export const SCREENING_SURVEYS_TEST = "SCREENING_SURVEYS_TEST"

//screening - early
export const SCREENING_EARLY_QUESTIONS_LIST = "SCREENING_EARLY_QUESTIONS_LIST"

//articles

export const ARTICLES = "ARTICLES"
export const AUTHORS = "AUTHORS"
export const REGIONS = "REGIONS"
export const KINDERGARTENS = "KINDERGARTENS"

export const THEME_LIST = "THEME_LIST"

export const KINDERGARTENS_LIST = "KINDERGARTENS_LIST"
export const CHILDRENS = "CHILDRENS"
export const REVIEWS_LIST = "REVIEWS_LIST"
export const MAIN_VIDEO_LIST = "MAIN_VIDEO_LIST"
export const CONTENT_BY_LESSON = "CONTENT_BY_LESSON"
export const EXPORT_PDF = "EXPORT_PDF"
export const SENSORY_VIDEO_LIST = "SENSORY_VIDEO_LIST"
export const EXPORT_RESULTS_PDF = "EXPORT_RESULTS_PDF"
export const INFOGRAPHICS_BY_CODE = "INFOGRAPHICS_BY_CODE"
export const ARTICLE_BY_ID = "ARTICLE_BY_ID"
export const DELETE_CHILD = "DELETE_CHILD"
export const PSYCHO_CARDS_LIST = "PSYCHO_CARDS_LIST"
export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const ADD_CHILD = "ADD_CHILD"
export const UPDATE_CHILD = "UPDATE_CHILD"
export const RESEND_CODE = "RESEND_CODE"
export const CONFIRM_RESET_PASSWORD = "CONFIRM_RESET_PASSWORD"
export const CONFIRM_PASSWORD = "CONFIRM_PASSWORD"
export const CARDS_THEME_LIST = "CARDS_THEME_LIST"
export const EVALUATE = "EVALUATE"
export const TEST_RESULTS = "TEST_RESULTS"
export const REGIONS_LIST = 'REGIONS_LIST';
export const DISTRICTS_LIST = 'DISTRICTS_LIST';
export const CITIES_LIST = 'CITIES_LIST';
export const LIST_REQUEST = 'LIST_REQUEST';
export const CREATE_APPLICATION = "CREATE_APPLICATION"
export const SET_LIKE = "SET_LIKE"
export const CONTENT_BY_CATEGORY = "CONTENT_BY_CATEGORY"
export const ARTICLE_LIST = "ARTICLE_LIST"
export const AUTORS_LIST = "AUTORS_LIST"

export const FETCH_MARATHON_WEEKS = 'FETCH_MARATHON_WEEKS'
export const FETCH_MARATHON_DAYS = 'FETCH_MARATHON_DAYS'
export const FETCH_MARATHON_TASKS = 'FETCH_MARATHON_TASKS'
export const FETCH_MARATHON_TASK = 'FETCH_MARATHON_TASK'
export const SAVE_DIARY = 'SAVE_DIARY'
export const FETCH_DIARY = 'FETCH_DIARY'
export const FETCH_DIARY_TABLE = 'FETCH_DIARY_TABLE'
export const TASK_COMPLETE = 'TASK_COMPLETE'
export const DIAGNOSTIC_RESULT = 'DIAGNOSTIC_RESULT'
export const SELECTED_CHILD_ID = 'SELECTED_CHILD_ID'
export const TASK_COMPLETED_LOCAL = 'TASK_COMPLETED_LOCAL'
